// Styles
import styles from './VirtualizedTableGroupItem.module.css';

/**
 * VirtualizedTableGroupItem - Wrapper for individual virtualized table group items
 * @param {object} params
 * @param {number} params.dataIndex - Index of the item in the data array
 * @param {React.Ref<HTMLDivElement>} params.measureRef - Ref for measuring element size
 * @param {number} params.start - Starting position (Y offset) for the item
 * @param {React.ReactNode} params.children - Children to render
 * @returns {JSX.Element} VirtualizedTableGroupItem component
 */
function VirtualizedTableGroupItem({
  dataIndex,
  measureRef,
  start,
  children,
}) {
  return (
    <div
      data-index={dataIndex}
      ref={measureRef}
      className={styles['virtualized-table-group-item']}
      style={{
        transform: `translateY(${start}px)`,
      }}
    >
      {children}
    </div>
  );
}

export default VirtualizedTableGroupItem;
